import * as DropdownPrimitives from "@radix-ui/react-dropdown-menu";
import "./faDropdownMenuDivider.scss";

export const FaDropdownMenuDivider = () => {
    return <DropdownPrimitives.Separator className="fa-dropdown-menu-divider" />;
};
